import { lazy } from 'react';

export const PendingPage = lazy(() => import('./PendingPage'));
